/* eslint-disable no-console */
import { analyticsState } from './analytics.state'
import type { IAnalyticsService, AnalyticAuthMethod, AnalyticUserProps } from './analytics.types'

export class AnalyticsService implements IAnalyticsService {
  protected _windowId: string
  protected _logging: boolean

  constructor(logging: boolean, windowId: string) {
    this._windowId = windowId
    this._logging = logging
  }

   public async init(): Promise<boolean> {
    const promises: Promise<boolean>[] = []
    analyticsState.clients().forEach((client) => promises.push(client.init()))
    await Promise.all(promises)
    return true
  }

  public login(method: AnalyticAuthMethod): void {
    analyticsState.clients().forEach((client) => client.login(method))
  }

  public signUp(method: AnalyticAuthMethod): void {
    analyticsState.clients().forEach((client) => client.signUp(method))
  }

  public userId(userId: string): void {
    if (this._logging) console.log('AnalyticsService: userId = %s', userId)
      analyticsState.clients().forEach((client) => client.userId(userId))
  }

  public userPropsGet(props: Partial<AnalyticUserProps> = {}): AnalyticUserProps {
    return {
      ...props,
    }
  }

  public userProps(props: AnalyticUserProps): void {
    if (this._logging) {
      console.group('AnalyticsService: userProp')
      Object.keys(props).forEach((name: string) =>
        console.log('%s: %s', name, props[name as keyof AnalyticUserProps]),
      )
      console.groupEnd()
    }
    analyticsState.clients().forEach((client) => client.userProps(props))
  }

  public event(event: string, data?: AnalyticUserProps): void {
    if (this._logging) console.group('AnalyticsService: ' + event)
      analyticsState.clients().forEach((client) => client.event(event, data))
    if (this._logging) console.groupEnd()
  }

  public flush(): void {
    analyticsState.clients().forEach((client) => {
      if (client?.flush) client.flush()
    })
  }
}
